module.exports = __webpack_public_path__ + "img/top-bg.e777f67d.png";